import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import type { IntroOffersAlertBody } from '../alertHover.types'
import { introOffersStyles } from './IntroOffers.styles'

const IntroOffersBody: React.FC<{ body: IntroOffersAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body) {
    return null
  }

  return (
    <Box sx={introOffersStyles.root}>
      <Typography sx={introOffersStyles.item}>
        {t('introOffers.count', { count: body.count ?? 0 })}
      </Typography>
    </Box>
  )
}

export default IntroOffersBody
